import Image from "next/image"
import { useTranslation } from "next-i18next";
import { useEffect, useRef, useState } from "react";

const EasyAndFastMailManagement = () => {
    const { t } = useTranslation(["common", "homepage", "email"]);
    const [currentIndex, setCurrentIndex] = useState(0);

    let sliderData = [
        {
            title: t("email:userManagement"),
            description: t("email:userManagementDesc"),
        },
        {
            title: t("email:storageManagement"),
            description: t("email:storageManagementDesc"),
        },
        {
            title: t("email:spamAndSecuritySettings"),
            description: t("email:spamAndSecuritySettingsDesc"),
        },
        {
            title: t("email:emailForwarding"),
            description: t("email:emailForwardingDesc"),
        },
        {
            title: t("email:automaticReplies"),
            description: t("email:automaticRepliesDesc"),
        },
        {
            title: t("email:backupAndRecovery"),
            description: t("email:backupAndRecoveryDesc"),
        },
        {
            title: t("email:performanceMonitoring"),
            description: t("email:performanceMonitoringDesc"),
        },
    ]

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % sliderData.length);
        }, 4000);

        return () => clearInterval(interval);
    }, [currentIndex, sliderData.length]);

    return (
        <div className="container py-5 mx-auto lg:py-20">
            <div className="grid px-2 lg:mx-auto lg:items-center lg:grid-cols-2">
                <div>
                    <div>
                        <p className="pb-4 text-lg text-titleColor">{t("email:mailManagementPanel")}</p>
                        <h2 className="pb-6 text-3xl font-bold text-titleColor lg:text-4xl">{t("email:easyAndFastMailManagement")}</h2>
                        <div className="pb-6 text-sm text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: t("email:easyAndFastMailManagementDesc") }}></div>
                    </div>

                    <div className="">
                        <h3 className="pb-8 text-base font-bold lg:text-xl text-titleColor">{t("email:introductionOfPanelFeatures")}:</h3>
                    </div>
                    <div className="relative h-[120px] lg:h-[150px] overflow-hidden">
                        {sliderData.map((item, index) => (
                            <div key={index} className={`absolute inset-0 transition-opacity duration-300 ease-in-out ${index === currentIndex ? "opacity-100" : "opacity-0"}`}>
                                <h4 className="pb-2 text-base font-bold lg:text-lg text-titleColor">{item.title}</h4>
                                <div className="text-sm font-medium text-textGray lg:text-base" dangerouslySetInnerHTML={{ __html: item.description }}></div>
                            </div>
                        ))}
                    </div>

                    <div className="flex gap-5 mt-4">
                        {sliderData.map((_, index) => (
                            <div key={index} className="w-10 lg:w-20 h-2 lg:h-2.5 rounded-full bg-makdosDarkPurple relative overflow-hidden cursor-pointer"
                                onClick={() => setCurrentIndex(index)}>
                                <div className={`absolute top-0 left-0 h-full bg-makdosYellow ${index === currentIndex ? "transition-all duration-[4s] w-full" : "w-0"}`}
                                ></div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="pt-10 lg:pt-0">
                    <Image src={"/EasyAndFastMailManagement.svg"} width={564} height={518} alt={t("email:easyAndFastMailManagement")} title={t("email:easyAndFastMailManagement")} />
                </div>
            </div>
        </div>
    )
}

export default EasyAndFastMailManagement